import HeaderImage from "../../assets/images/main_header.jpg";
import {Breadcrumb, Button, Image, Table} from "antd";
import {Link} from "react-router-dom";
import {FilePdfOutlined} from "@ant-design/icons";

import Image1 from "../../assets/images/factory4.jpg";
import Image2 from "../../assets/images/factory3.jpg";
import TY081130_001File from "../../assets/files/TY 08.11.30-001.pdf";

const MDP1 = () => {


    const images = [
        { id: 1, src: Image1, alt: "МТП-1 вид 1" },
        { id: 2, src: Image2, alt: "МТП-1 вид 2" },
    ];

    const tableData = [
        { key: "1", number: 1, indicator: "Массовая доля влаги", value: "не более 0,2%" },
        {
            key: "2",
            number: 2,
            indicator: "Суммарная доля углекислого кальция и углекислого магния в пересчете на углекислый кальций",
            value: "не менее 98%"
        },
        {
            key: "3",
            number: 3, indicator: "Массовая доля веществ, не растворимых в HC1",
            value: "Не более 1,5%"
        },
        { key: "4", number: 4, indicator: "Массовая доля полуторных оксидов железа и аллюминия ", value: "не более 0,6%" },
        { key: "5", number: 5, indicator: "Массовая доля оксида железа (III)", value: "не более 0,25%" },
        { key: "6", number: 6, indicator: "Массовая доля марганца", value: "не более 0,02%" },
        { key: "7", number: 7, indicator: "Массовая доля меди", value: "не более 0,001%" },
        { key: "8", number: 8, indicator: "Массовая доля железа, извлекаемого магнитом", value: "не более 0,02%" },
        { key: "9", number: 9, indicator: "Коэффициент отражения", value: "не менее 90%" },
        {
            key: "10",
            number: 10,
            indicator: "Допустиомое значение удельной эффективной активности природных радионуклидов (радий - 226, торий - 232)",
            value: "не боле 370 Бк/кг"
        },
        { key: "11", number: 11, indicator: "Остаток на сите с сеткой № 014", value: "не более 0,8%" },
    ];

    const tableColumns = [
        {
            title: "№",
            dataIndex: "number",
            key: "number",
            width: 80,
            align: "center",
        },
        {
            title: "Показатели",
            dataIndex: "indicator",
            key: "indicator",
            width: "65%",
        },
        {
            title: "Численные значения, нормированные по ТУ",
            dataIndex: "value",
            key: "value",
        },
    ];

    return(
        <div className={"product-container"}>
            <div className={"product-container-image"}>
                <img src={HeaderImage} alt="Header Background" style={{width: "100%"}}/>
            </div>

            <div className={"product-header"}>
                <h1>МДП-1</h1>
                <Breadcrumb className="product-header-breadcrumb"
                            items={[
                                {
                                    title: <Link to="/">Главная страница</Link>
                                },
                                {
                                    title: <Link to="/productions">Продукция</Link>
                                },
                                {
                                    title: <span>МДП-1</span>,
                                },
                            ]}
                />
                <div className="under-breadcrumb-divider"></div>
            </div>

            <div className={"product-content"}>
                <div className={"product-content-image-column"}>
                    <Button
                        type="primary"
                        icon={<FilePdfOutlined/>}
                        size="large"
                        onClick={() => window.open(TY081130_001File, "_blank", "noopener,noreferrer")}
                        className="pp-pdf-button"
                    >
                        Посмотреть ТУ
                    </Button>

                    <div className="images-grid">
                        {images.map((image) => (
                            <div className="image-wrapper" key={image.id}>
                                <Image
                                    src={image.src}
                                    alt={image.alt}
                                    className="pp-image"
                                    preview={{
                                        src: image.src,
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                </div>


                <div className={"product-content-text-column"}>
                    <div className={"product-content-text-column"}>
                        <div className={"product-content-description"}>
                            <h2>Описание продукта</h2>
                            <p>
                                <strong>МДП-1</strong> — это природный сухомолотый мел, получаемый путем высушивания и
                                измельчения рыхлой известняковой породы. Как и другие марки тонкодисперсного мела, он
                                представляет собой порошкообразный материал с низкой абразивностью и выступает в
                                качестве
                                эффективного минерального наполнителя в различных отраслях промышленности.
                            </p>

                            <h3>Основные характеристики:</h3>
                            <ul>
                                <li>Порошкообразная форма с малой абразивностью, что характерно для природного
                                    сухомолотого мела
                                </li>
                                <li>
                                    Соответствие требованиям радиационной безопасности: удельная эффективная активность
                                    естественных радионуклидов не превышает 370 Бк/кг,
                                    что соответствует нормам СанПиН 2.6.1.2523
                                </li>
                                <li>
                                    Химическая нейтральность: мел (карбонат кальция, CaCO₃) является химически
                                    стабильным
                                    соединением, что обеспечивает его совместимость с различными компонентами в
                                    производственных составах
                                </li>
                            </ul>

                            <h3>Области применения:</h3>
                            <ul>
                                <li>
                                    Производство лакокрасочных материалов (ЛКМ): используется в водно-дисперсионных,
                                    фасадных, масляных красках, грунтовках и шпатлевках в качестве
                                    наполнителя-разбавителя
                                    (экстендера), улучшающего укрывистость, вязкость и формирующего гладкое покрытие
                                </li>
                                <li>
                                    Производство строительных материалов: является компонентом сухих строительных
                                    смесей,
                                    штукатурок, шпаклевок, а также используется при производстве керамического кирпича и
                                    плитки
                                </li>
                                <li>
                                    Целлюлозно-бумажная промышленность: применяется в качестве наполнителя для повышения
                                    белизны, гладкости и непрозрачности бумаги.
                                </li>

                                <li>
                                    Производство полимеров, пластмасс и резинотехнических изделий (РТИ): выступает
                                    наполнителем в композитах на основе ПВХ, полимерных смесях и резинах, улучшая их
                                    механические свойства, износостойкость и снижая себестоимость.
                                </li>

                                <li>
                                    Текстильная и химическая промышленность.
                                </li>
                            </ul>

                            <h3>Преимущества:</h3>
                            <ul>
                                <li>
                                    Функциональность в составах: выступает как наполнитель, разбавитель и стабилизатор,
                                    способствуя упрочнению конечного материала и регулированию его свойств (например,
                                    вязкости)
                                </li>
                                <li>
                                    Экономическая эффективность: как доступный минерал, мел позволяет снижать
                                    себестоимость
                                    готовой продукции, частично замещая более дорогие компоненты (например, диоксид
                                    титана в красках) без критической потери качества
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MDP1;